/**
 * Console-safe description of a caught error.
 *
 * A raw axios error carries `config` (request body, which can hold a
 * password or supplier key, and the Authorization header), `request`, and
 * `response.data`. Logging it dumps all of that into the browser console.
 * Log `describeError(err)` instead: only status, code and a message.
 *
 * Never returns config / request / headers / response.data.
 *
 * Residual: `message` is passed through VERBATIM. Axios-generated messages
 * ("Request failed with status code 401", "Network Error") are safe, but a
 * non-axios Error or a plain string that echoes user input can carry it.
 * Callers must not pass strings built from credentials.
 */
export function describeError(err) {
  if (err === null || err === undefined) {
    return { status: null, code: null, message: 'Unknown error' }
  }
  if (typeof err === 'string') {
    // A bare string is the caller's own text, not a transport object.
    return { status: null, code: null, message: err }
  }
  const status = err.response && typeof err.response.status === 'number'
    ? err.response.status
    : null
  const code = typeof err.code === 'string' ? err.code : null
  const message = typeof err.message === 'string' ? err.message : 'Unknown error'
  return { status, code, message }
}

export default describeError
